/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    AcceptInfo: {
        id: 'declarationsDocuments.AcceptInfoUnoccupancy',
        defaultMessage: 'By clicking Accept, you confirm that you have read the following:'
    },
    ImportantInfoLink: {
        id: 'declarationsDocuments.ImportantInfoLinkUnoccupancy',
        defaultMessage: 'Important information'
    },
    RenewalPageIpidDocumentsLink: {
        id: 'declarationsDocuments.RenewalPageDocumentsLink',
        defaultMessage: 'The Insurance Product Information Document at the end of your renewal invitation pack, which can be found in '
    },
    RenewalPage003Endorsement: {
        id: 'declarationsDocuments.RenewalPage003Endorsement',
        defaultMessage: 'The “Vacant Property” endorsement in your renewal invitation pack. You understand that this limits the cover provided by this policy to claims for Fire, Lightning, Explosion, Earthquake, Impact by aircraft or other aerial devices and anything dropped from them, and your public liability only.'
    },
    DocumentsLink: {
        id: 'declarationsDocuments.MyDocumentsUnoccupancy',
        defaultMessage: 'My Documents.'
    },
});
